import { aplClient } from "./apiClient";
import { PalletDetail } from "../types/palletDetail";
import { Activity } from "../types/activity";
import { AxiosResponse } from "axios";
import { MomentObject } from "../types/momentObject";

/// <summary>
/// Issues a pallet to a line
/// On success show success message and reload the grid
/// On error show error message and reload the grid
/// </summary>
const issuePallet = async (
    sscc: string,
    lineId: number,
    workorderId: string,
    operationId: string,
    offline: boolean,
    consumptionStart?: MomentObject,
    consumptionEnd?: MomentObject
): Promise<AxiosResponse<any, any>> => {
    let issuingRequest = {
        sscc: sscc,
        lineId: lineId,
        workorderId: workorderId,
        operationId: operationId,
        offline: offline,
        consumptionStart: consumptionStart,
        consumptionEnd: consumptionEnd
    };
    return aplClient().post("consumptiondetails", issuingRequest);
};

const issuePalletOnline = async (palletDetail: PalletDetail, activitiy: Activity): Promise<AxiosResponse<any, any>> => {
    return issuePallet(palletDetail.sscc, activitiy.lineId, activitiy.workOrderId, activitiy.operationId, false);
};

const issuePalletOffline = async (
    palletDetail: PalletDetail,
    activitiy: Activity,
    dtstart: MomentObject,
    dtEnd: MomentObject
): Promise<AxiosResponse<any, any>> => {
    return issuePallet(palletDetail.sscc, activitiy.lineId, activitiy.workOrderId, activitiy.operationId, true, dtstart, dtEnd);
};

const consumePallet = async (consumptionId: string, qtyConsumed: number): Promise<AxiosResponse<any, any>> =>
    aplClient().put(`consumptiondetails/consume/${consumptionId}`, qtyConsumed);

const getIssuedPallets = async (operationId: string): Promise<AxiosResponse<any, any>> =>
    aplClient().get(`consumptiondetails/issued/${operationId}`);

const getConsumptionDetailsByOperationId = (operationId: string) => aplClient().get(`consumptiondetails/${operationId}`);
const getActivityAndConsumptionDetailsByOperationId = (operationId: string) => aplClient().get(`consumptiondetails/byoperationid/${operationId}/consumption`);
const getActivityAndConsumptionDetailsByLineId = (lineId: number) => aplClient().get(`consumptiondetails/bylineid/${lineId}/consumption`);

const getIssuedPalletsByOperationId = (operationId: string) => aplClient().get(`consumptiondetails/issued/${operationId}`);

const returnPallet = async (consumptionId: string, qtyRemaining: number) =>
    aplClient().put(`consumptiondetails/return/${consumptionId}`, qtyRemaining);

const deleteConsumption = async (consumptionId: string) => aplClient().delete(`consumptiondetails/${consumptionId}`);

export {
    issuePalletOnline,
    issuePalletOffline,
    getIssuedPallets,
    getConsumptionDetailsByOperationId,
    getIssuedPalletsByOperationId,
    consumePallet,
    returnPallet,
    deleteConsumption,
    getActivityAndConsumptionDetailsByOperationId,
    getActivityAndConsumptionDetailsByLineId
};
